import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as Styled from './Tag.styled';

const Tag = (props) => {
  const { classes, children, variant, className } = props;
  return (
    <Styled.TagContainer
      className={classNames(classes.root, className)}
      variant={variant}>
      {children}
    </Styled.TagContainer>
  );
};

Tag.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string,
  }),
  variant: PropTypes.oneOf([
    'error',
    'negative',
    'warning',
    'success',
    'info',
    'slighter',
  ]),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

Tag.defaultProps = {
  className: '',
  classes: {
    root: '',
  },
  variant: 'info',
  children: null,
};

export default Tag;
